import { CityTabId } from '../../types';

export const CITY_NAME_TO_TAB_ID: Record<string, CityTabId> = {
    москва: 'moscow',
    'санкт петербург': 'spb',
    воронеж: 'voronezh',
    казань: 'kazan',
    саратов: 'saratov',
    самара: 'samara',
    'нижний новгород': 'nizhny-novgorod',
    уфа: 'ufa',
    краснодар: 'krasnodar',
    'ростов на дону': 'rostov-on-don',
    симферополь: 'simferopol',
    ставрополь: 'stavropol',
    екатеринбург: 'ekaterinburg',
    красноярск: 'krasnoyarsk',
    новосибирск: 'novosibirsk',
};
